import { createContainer } from 'react-sweet-state';

import { ACTIONS, DocumentViewStore } from './DocumentViewStore';

export const DocumentViewStoreContainer = createContainer(DocumentViewStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(ACTIONS.init());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(ACTIONS.update());

      if (state) {
        setState(state);
      }
    },
});
